import React, { useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import SvgIcon from '../../../../components/Icon/Icon';
import ChevronChico from '../../../../components/ChevronChico';
import { useQuery } from '@tanstack/react-query';
import useActiveAdminCommunity from '../../../../hooks/useActiveAdminCommunity';
import api from '../../../../utils/api';
import Header from '../../../../navigation/Header';
import NewAdminModal from './NewAdminModal';
import AdminUserDetailModal from './AdminUserDetailModal';
import IconButton from '../../../../components/IconButton';


interface AdminUser {
  uuid: string;
  name: string;
  email: string;
  phone_number: string;
  is_registered: boolean;
  roles: Array<{
    name: string;
    display_name: string;
  }>;
}


function UserRow({ user, onPress }: { user: AdminUser; onPress: () => void }) {
  const roleNames = user.roles?.map(role => role.display_name ?? role.name).join(', ');

  return (
    <TouchableOpacity
      style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-4 mb-3 row items-center`}
      onPress={onPress}
    >
      <View style={tw`flex-1`}>
        <View style={tw`row items-center`}>
          <Text style={tw`text-secondary font-500`}>{user.name}</Text>
          {user.is_registered && (
            <SvgIcon name='verified' size={16} color={tw.color('primary')} style={tw`ml-1`} />
          )}
        </View>
        {!!roleNames && (
          <Text style={tw`text-gray-500 text-sm`}>{roleNames}</Text>
        )}
      </View>

      <ChevronChico />
    </TouchableOpacity>
  )
}


export default function AdminUsersScreen({ navigation }) {
  const { communityId } = useActiveAdminCommunity()
  const [showNewUserModal, setShowNewUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<AdminUser | null>(null);

  const { data: users, refetch, isLoading } = useQuery({
    queryKey: ['community.staff', communityId],
    queryFn: () => api.get(`/communities/${communityId}/staff`).then(response => response.data),
  })

  return (
    <View style={tw`flex-1 bg-background`}>
      <Header showBackButton title="Equipo" style="bg-transparent" />

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 pt-4 pb-10`}>
        {/* Lista del equipo */}
        {users?.map((user: AdminUser) => (
          <UserRow
            key={user.uuid}
            user={user}
            onPress={() => setSelectedUser(user)}
          />
        ))}

        {isLoading && (
          <Text style={tw`text-center text-gray-400 py-8`}>Cargando...</Text>
        )}

        {/* Botón agregar al equipo */}
        <TouchableOpacity
          style={tw`border-2 border-dashed border-primary rounded-2xl px-4 py-4 row items-center justify-center`}
          onPress={() => setShowNewUserModal(true)}
        >
          <Icon name='add1' size={20} color={tw.color('primary')} style={tw`mr-2`} />
          <Text style={tw`text-primary font-500`}>Agregar al equipo</Text>
        </TouchableOpacity>
      </ScrollView>

      {/* Modal alta en el equipo */}
      {showNewUserModal && (
        <NewAdminModal
          visible={showNewUserModal}
          onRequestClose={() => setShowNewUserModal(false)}
          onUserCreated={() => {
            setShowNewUserModal(false)
            refetch()
          }}
        />
      )}

      {/* Modal detalle de la persona */}
      {selectedUser && (
        <AdminUserDetailModal
          visible={!!selectedUser}
          user={selectedUser}
          onRequestClose={() => setSelectedUser(null)}
          onUserUpdated={() => {
            setSelectedUser(null)
            refetch()
          }}
          onUserDeleted={() => {
            setSelectedUser(null)
            refetch()
          }}
        />
      )}
    </View>
  );
}
